<template>
    <div class="animated fadeIn">
        <table class="kgr-table kgr-table--block data-table table-groups table-employees printable">
            <thead>
                <tr class="kgr-table__row">
                    <th class="kgr-table__cell kgr-table__cell--headline">
                        {{ $t('department.name') }}
                    </th>

                    <th
                        v-for="level in childDepartmentLevels"
                        class="kgr-table__cell kgr-table__cell--headline"
                    >
                        {{ $t('department.childDepartments') }} ({{ $t('Ebene {level}', {'level': level}) }})
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr
                    v-for="(row, index) in tableRows"
                    class="kgr-table__row"
                    :class="{'is-striped': index % 2 === 0}"
                >
                    <td
                        v-for="department in row"
                        class="kgr-table__cell"
                    >
                        <template v-if="department">
                            <a
                                v-if="department.isViewable || department.isEditable"
                                :href="urlForDepartmentEdit(department.id)"
                                class="kgr-link"
                            >
                                {{ department.name }}
                            </a>
                            <template v-else>
                                {{ department.name }}
                            </template>
                        </template>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import UrlMixin from './UrlMixin';

export default {
    name: 'KgrDepartmentsTable',
    mixins: [UrlMixin],
    props: {
        departments: {
            type: Array,
            required: true,
        },
        filter: {
            type: String,
            required: false,
        },
    },
    computed: {
        childDepartmentLevels() {
            return this.countChildDepartmentLevel(this.departments, 0);

        },
        tableRows() {
            return this.createRows(this.departments, [], 0);
        },
    },
    methods: {
        countChildDepartmentLevel(departments, level) {
            let maxLevel = 0;
            departments.forEach(department => {
                let newLevel;

                if (department.childDepartments.length === 0) {
                    newLevel = level;
                } else {
                    newLevel = this.countChildDepartmentLevel(department.childDepartments, level + 1);
                }

                if (newLevel > maxLevel) {
                    maxLevel = newLevel;
                }
            });

            return maxLevel;
        },
        createRows(departments, rows, level) {
            departments.forEach(department => {
                const row = this.createRow(department, level);

                rows.push(row);
                rows = this.createRows(department.childDepartments, rows, level + 1)
            });

            return rows;
        },
        createRow(department, level) {
            if (!this.departmentMatchesFilter(department)) {
                return null;
            }

            const row = [];
            for (let i = 0; i < level; i++) {
                row.push(null);
            }

            row.push(department);

            for (let i = 0; i < this.childDepartmentLevels - level; i++) {
                row.push(null);
            }

            return row;
        },
        departmentMatchesFilter(department) {
            if (null !== this.filter && '' !== this.filter) {
                const filter = this.filter.toLowerCase().trim();
                return department.name.toLowerCase().indexOf(filter) !== -1
                        || (department.shortName && department.shortName.toLowerCase().indexOf(filter) !== -1)
                        || (department.hierarchyPath && department.hierarchyPath.toLowerCase().indexOf(filter) !== -1);
            }

            return true;
        }
    },
}
</script>

<style scoped lang="scss" rel="stylesheet/scss"></style>
